'use client';

import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';
import * as fbq from "./fbq";
import { jsx as _jsx } from "react/jsx-runtime";
var sendPageView = function sendPageView() {
  fbq.pageview();
};
export var FacebookPixel = function FacebookPixel() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var pathname = usePathname();
  useEffect(function () {
    if (!loaded) return;
    sendPageView();
  }, [pathname, loaded]);
  return /*#__PURE__*/_jsx(Script, {
    id: "fb-pixel",
    strategy: "afterInteractive",
    onLoad: function onLoad() {
      return setLoaded(true);
    },
    children: "!function(f,b,e,v,n,t,s)\n                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n                n.queue=[];t=b.createElement(e);t.async=!0;\n                t.src=v;s=b.getElementsByTagName(e)[0];\n                s.parentNode.insertBefore(t,s)}(window, document,'script',\n                'https://connect.facebook.net/en_US/fbevents.js');\n                fbq('init', '".concat(process.env.NEXT_PUBLIC_FB_PIXEL_ID, "');")
  });
};